'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _tableLocal = require('./table.local.css');

var _tableLocal2 = _interopRequireDefault(_tableLocal);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var TableBody = function TableBody(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return _react2.default.createElement('tbody', {
    className: (0, _classnames2.default)(_tableLocal2.default.body, className)
  }, children);
};

TableBody.propTypes = {
  /**
   * Node to render within the tbody
   */
  children: _propTypes2.default.node,

  /**
   * Classname to apply to the tbody node
   */
  className: _propTypes2.default.string
};
exports.default = TableBody;